import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatType } from "types/loadedData";

interface StatState {
  totalStat: StatType | null;
  todayStat: StatType | null;
}

const initialState: StatState = {
  totalStat: null,
  todayStat: null,
};

export const chat = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setTotalStat: (state, action: PayloadAction<StatType | null>) => {
      state.totalStat = action.payload;
    },
    setTodayStat: (state, action: PayloadAction<StatType | null>) => {
      state.todayStat = action.payload;
    },
  },
});

export const { setTodayStat, setTotalStat } = chat.actions;

export default chat.reducer;
